import React, { Component } from "react";

const initData = {
  heading: "Policies & Codes",
  headingText:
    "Thousands of customers have benefited from MoneyMonk’s Financial services. Listen to what they have to say.",
  headingTexttwo:
    "Thousands of customers have benefited from MoneyMonk’s Financial services. Listen to what they have to say.",
};

const data = [
  {
    id: "1",
    avatorImg: "/img/avatar-1.png",
    reviewer: "Junaid Hasan",
    post: "CEO, Themeland",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Terms & Conditions",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star text-warning",
    path: "/termsandconditions",
  },
  {
    id: "2",
    avatorImg: "/img/avatar-2.png",
    reviewer: "Jassica William",
    post: "Web Designer",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Interest Rate Policy ",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star-half-alt text-warning",
    path: "/interestrate",
  },
  {
    id: "3",
    avatorImg: "/img/avatar-3.png",
    reviewer: "Johnson Smith",
    post: "SEO Expert",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Privacy Policy",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star text-warning",
    path: "/privacypolicy",
  },

  {
    id: "4",
    avatorImg: "/img/avatar-3.png",
    reviewer: "Johnson Smith",
    post: "SEO Expert",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Loan Closure Policy",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star text-warning",
    path: "/loanclosurepolicy",
  },
    {
    id: "5",
    avatorImg: "/img/avatar-3.png",
    reviewer: "Johnson Smith",
    post: "SEO Expert",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Fair Practice Code",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star text-warning",
    path: "/fairpracticecode",
  },
    {
    id: "6",
    avatorImg: "/img/avatar-3.png",
    reviewer: "Johnson Smith",
    post: "SEO Expert",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis nam id facilis, provident doloremque placeat eveniet molestias laboriosam. Optio, esse.",
    comments: "Other Policies",
    quotIcon: "/img/quote.png",
    icon_1: "fas fa-star text-warning",
    icon_2: "fas fa-star text-warning",
    icon_3: "fas fa-star text-warning",
    icon_4: "fas fa-star text-warning",
    icon_5: "fas fa-star text-warning",
    path: "/policiesandcodes",
  },
];

class PoliciesAndCodesSection extends Component {
  state = {
    initData: {},
    data: [],
  };
  componentDidMount() {
    this.setState({
      initData: initData,
      data: data,
    });
  }
  render() {
    return (
      <section
        id="policiesandcodes"
        className="section screenshots-area ptb_100"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-7">
              {/* Section Heading */}
              <div className="section-heading text-center">
                <h2 className="text-capitalize">
                  {this.state.initData.heading}
                </h2>
                <p className="d-none d-sm-block mt-4">
                  {this.state.initData.headingText}
                </p>
                <p className="d-block d-sm-none mt-4">
                  {this.state.initData.headingTexttwo}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {this.state.data.map((item, idx) => {
              return (
                <div
                  key={`ro_${idx}`}
                  className="col-12 col-md-6 col-lg-4 res-margin mb-4"
                >
                  {/* Single Review */}
                  <a  href={item.path}>
                    <div className="single-review card">
                      {/* Card Top */}
                      <div className="card-top p-4">
                        {/* <div className="review-icon">
                                              <i className={item.icon_1} />
                                              <i className={item.icon_2} />
                                              <i className={item.icon_3} />
                                              <i className={item.icon_4} />
                                              <i className={item.icon_5} />
                                          </div> */}
                        <h4 className="text-primary mb-2" style={{textAlign:'center'}}>
                          {item.comments}
                        </h4>
                        {/* Review Text */}
                        {/* <div className="review-text">
                          <p>{item.text}</p>
                        </div> */}
                      </div>
                      {/* Reviewer */}
                      {/* <div className="reviewer bg-gray p-3 text-center"> */}
                        {/* <a href={item.path} style={{}}>
                          Click here
                        </a> */}
                        {/* Reviewer Thumb */}
                        {/* <div className="reviewer-thumb">
                                              <img className="avatar-lg radius-100" src={item.avatorImg} alt="" />
                                          </div> */}
                        {/* Reviewer Media */}
                        {/* <div className="reviewer-meta media-body align-self-center ml-4">
                                              <h5 className="reviewer-name color-primary mb-2">{item.reviewer}</h5>
                                              <h6 className="text-secondary fw-6">{item.post}</h6>
                                          </div> */}
                      {/* </div> */}
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default PoliciesAndCodesSection;
